import Vue from "vue";
import Router from "vue-router";
import Search from "./components/Search.vue";
import Profile from "./components/Profile.vue";
import Main from "./components/Main.vue";
import NotFound from "./components/NotFound.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/:game",
      name: "search",
      component: Search
    },
    {
      path: "/:game/profile/:platform/:gamertag",
      name: "profile",
      component: Profile
    },
    {
      path: "/",
      name: "main",
      component: Main
    },
    {
      path: '*',
      name: 'notfound',
      component: NotFound
    }
  ],
  mode: "history"
});
